import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PinkNotification, RegularInput } from "../../../atoms";

type TInputType = "email" | "nickname" | "fullName";

interface ICreateUserInputGeneric {
    type: TInputType;
    message: string;
    value: string;
    handleOnChange(type: TInputType, value: any): void;
    validateInputs(type: TInputType): void;
}

const CreateUserInputGeneric: FC<ICreateUserInputGeneric> = (props) => {
    const {type, message, value, handleOnChange, validateInputs} = props;
    const { t } = useTranslation();

    const labelDic = {
        "email": t("emailBigText"),
        "nickname": t("nicknameBigText"),
        "fullName": t("fullNameBigText"),
    }

    const fieldNameDic = {
        "email": t("emailText"),
        "nickname": t("nicknameText"),
        "fullName": t("fullNameText"),
    }

    const maxNumberOfCharactersDic = {
        "email": 50,
        "nickname": 12,
        "fullName": 40
    }

    return (
        <div className="input_wrapper" >
            <div className="regular_input">
                <PinkNotification notificationWidthVW={25} notificationRenderingSide="right" text={message} moveFromTop={20} />
                <RegularInput
                    label={labelDic[type]}
                    value={value}
                    onChange={(value: string) => handleOnChange(type, value)}
					inputBlurText={() => validateInputs(type)}
                    fieldName={fieldNameDic[type]}
                    maxLength={maxNumberOfCharactersDic[type]}
                />
            </div>
        </div>
    )
}

export default CreateUserInputGeneric;